module.exports = __webpack_public_path__ + "fonts/NotoSans-Light.e67b35e5.woff2";